export default __webpack_public_path__ + "26addae8535c92177df2ccf269486859.png";